
export default (axios) => ({
  getAllPayments(queryString) {
    return axios.get("/payments", {
      params: queryString
    })
  }
})